import { createApp } from 'vue';
import Rw2ToWebpConverter from '../Components/Rw2ToWebpConverter.vue';

const root = document.getElementById('rw2-to-webp-converter');
if (root) {
  createApp(Rw2ToWebpConverter).mount('#rw2-to-webp-converter');
}
